import { Injectable, Injector } from '@angular/core'
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http'
import { catchError, map, Observable, throwError } from 'rxjs'
import { ToasterService } from '@shared/services/toaster'
import { TranslateService } from '@shared/services/translate'
import locales from '@shared/locales/failed-requests.locales'
import { Router } from '@angular/router'

@Injectable()
export class FailedRequestsInterceptor implements HttpInterceptor {
  constructor(
    private injector: Injector,
    private router: Router,
    private translate: TranslateService
  ) {}

  private toaster: ToasterService
  private t = this.translate.create(locales)

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event) => event),
      catchError((error: HttpErrorResponse) => {
        if ([500, 502].includes(error.status)) {
          if (request.url.match(/\/accounts\/(\d+)\/current/g)) {
            this.redirectTo(error.status)
          } else {
            this.showErrorToast(error)
          }
        }

        return throwError(() => error)
      })
    )
  }

  private redirectTo(errorPageCode: number): void {
    this.router.navigate([`/${errorPageCode}`])
  }

  private showErrorToast(error: HttpErrorResponse): void {
    if (!this.toaster) {
      this.toaster = this.injector.get(ToasterService)
    }

    setTimeout(() => {
      this.toaster?.errorHTTP(error)
    })
  }
}
